import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const DetailTopContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: row;
  position: absolute;
  left: ${136 * Screen.widthRatio}px;
  top: ${40 * Screen.widthRatio}px;
`;

export default DetailTopContainer;
